import React from 'react';
import SmallSpinner from '../../ScrollReader/SocialControls/SmallSpinner';

const SlidingDrawer = ({ className, id, title, onClick, actionBar, opened, loading, children }) => (
  <div id={id} className={`a-drawer ${className} ${opened ? 'opened' : ''}`}>
    <div className='a-drawer-header'>
      <p className='a-font-size-2 gray-2 m0'>
        <span>{title}</span>
        <a className='right a-comment-close-icon' href={EMPTY_HREF} onClick={e => { e.preventDefault(); onClick() }}></a>
      </p>
    </div>
    <div className='a-drawer-body'>
      {loading && <SmallSpinner />}
      {children}
    </div>
    <div className='a-drawer-footer'>
      {actionBar}
    </div>
  </div>
);

export default SlidingDrawer;
